import { render, staticRenderFns } from "./we-header.vue?vue&type=template&id=70027c23&"
import script from "./we-header.vue?vue&type=script&lang=js&"
export * from "./we-header.vue?vue&type=script&lang=js&"
import style0 from "./we-header.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports